import { Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { JobMaterialItem } from './po-line-item.model'
import { PoCommonFieldsComponent } from './po-common-fields.component'

@Component({
    selector: 'app-job-material-form',
    templateUrl: './job-material-form.component.html',
    standalone: true,
    imports: [FormsModule, PoCommonFieldsComponent],
})
export class JobMaterialFormComponent {
    item = input.required<JobMaterialItem>()
}
